module.exports = __webpack_public_path__ + "static/media/she_loves_data_logo.b3b7fff2.png";